export function removeQueryParamFromURL(router, to, param) {
  const params = new URLSearchParams(location.search);
  params.delete(param);
  router.replace(`${to.path}?${params}${to.hash}`);
}
